import {
    IPromise
} from 'angular';
import {
    hasOwnProperty,
    IPeopleModel
} from '../../tn.common';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';

function indexArrayBy<T>(arr: T[], prop: string) {
    const index: Record<string, T> = {};
    return arr.reduce<Record<string, T>>((acc, i) => {
        if (!hasOwnProperty(i, prop)) return acc;
        const idx: string = i[prop].toString();
        acc[idx] = i;
        return acc;
    }, index);
}

export class PeopleService {
    protected peoplePromise?: IPromise<Record<string, IPeopleModel>>;
    protected peopleIdx: Record<string, IPeopleModel> = {};

    static $inject = ['djangoClient'];
    constructor(protected djangoClient: DjangoClient) {

    }

    public listPeople(): IPromise<Record<string, IPeopleModel>> {
        if (this.peoplePromise) return this.peoplePromise;
        this.peoplePromise = this.djangoClient
            .getPaged<IPeopleModel>('/api/1/people/')
            .then((response) => {
                this.peopleIdx = indexArrayBy(response.results, 'id');
                return this.peopleIdx;
            });
        return this.peoplePromise;
    }

    public getPeople(ids: number[]): IPromise<IPeopleModel[]> {
        return this.listPeople().then(() => ids.map((id) => this.peopleIdx[id]));
    }

    public getPerson(id: number): IPromise<IPeopleModel> {
        return this.listPeople().then(() => this.peopleIdx[id]);
    }
}
